import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/cultural-platform.css';

const WhatIsSoftPower = () => {
  return (
    <div className="article-page" data-testid="what-is-soft-power-page" style={{ background: '#FFFFFF' }}>
      {/* Hero */}
      <section style={{
        padding: '120px 24px 80px',
        background: '#FFFFFF',
        borderBottom: '1px solid #DADCE0'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h1 style={{
            fontFamily: 'Google Sans, Roboto, sans-serif',
            fontSize: 'clamp(36px, 5vw, 56px)',
            fontWeight: '400',
            color: '#202124',
            marginBottom: '24px'
          }}>
            What is Soft Power?
          </h1>
          <p style={{
            fontSize: '18px',
            color: '#5F6368',
            lineHeight: '1.7'
          }}>
            Understanding the strength of cultural influence
          </p>
        </div>
      </section>

      {/* Article Content */}
      <section style={{ padding: '80px 24px', background: '#FFFFFF' }}>
        <article style={{ maxWidth: '720px', margin: '0 auto' }}>
          <div style={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '18px',
            lineHeight: '1.9',
            color: '#202124'
          }}>
            <p style={{ marginBottom: '32px' }}>
              Soft Power is the strength of a nation that doesn't rely on force — but on influence.
              Not on control — but on culture.
              Not on fear — but on respect, admiration and trust.
            </p>
            
            <p style={{ marginBottom: '32px' }}>
              It is the ability to shape the world through arts, films, heritage, ideas, values and identity.
              It is how nations are remembered.
              It is how nations are understood.
              It is how nations are welcomed.
            </p>
            
            <p style={{ 
              marginBottom: '32px',
              fontSize: '20px',
              fontWeight: '500',
              color: '#1A73E8'
            }}>
              And today, more than ever, the world needs a new kind of influence.
              That is why Project Soft Power exists.
            </p>

            <div style={{
              background: '#F8F9FA',
              padding: '32px',
              borderRadius: '8px',
              marginBottom: '32px',
              borderLeft: '4px solid #1A73E8'
            }}>
              <p style={{ margin: 0 }}>
                Project Soft Power is a government allied independent arts, films and cultural development 
                initiative founded by Leander Lee Marty built to leverage Arts, Films, and Culture as 
                strategic soft power, strengthening national identity, cultural influence, and international collaboration.
              </p>
            </div>

            <p style={{ marginBottom: '32px' }}>
              In a time where people quickly criticize their own nation, we believe in something deeper:
              Every country has flaws but every country also has greatness — and it is our responsibility 
              to highlight that greatness with dignity.
            </p>

            <p style={{ marginBottom: '32px' }}>
              Project Soft Power stands for positive national representation — not division.
              For constructive expression — not negativity.
              For cultural diplomacy — not conflict.
            </p>

            <p style={{ marginBottom: '32px' }}>
              Because when nations learn to celebrate themselves with pride and respect others with openness, 
              the world moves closer to unity.
            </p>

            <p style={{ marginBottom: '32px' }}>
              This is a global movement where artists, filmmakers, cultural leaders and creators across nations 
              come together to build something that has never existed before — a cross-cultural ecosystem of 
              collaboration, creativity, and exchange.
            </p>

            <div style={{
              background: '#F8F9FA',
              padding: '32px',
              borderRadius: '8px',
              marginBottom: '32px',
              textAlign: 'center'
            }}>
              <p style={{ 
                margin: 0,
                fontSize: '20px',
                color: '#202124'
              }}>
                A platform where countries don't compete in hate,
                <br />but inspire through excellence.
                <br />Where stories become bridges.
                <br />Where culture becomes peace.
              </p>
            </div>
          </div>

          {/* Navigation */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: '48px',
            borderTop: '1px solid #DADCE0',
            marginTop: '48px'
          }}>
            <Link to="/" style={{
              color: '#1A73E8',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              ← Back to Home
            </Link>
            <Link to="/one-shared-responsibility" style={{
              color: '#1A73E8',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              Next: One Shared Responsibility →
            </Link>
          </div>
        </article>
      </section>
    </div>
  );
};

export default WhatIsSoftPower;
